import { render, staticRenderFns } from "./RelatedVehicleDataUnitAgent.vue?vue&type=template&id=da78018a&scoped=true&"
import script from "./RelatedVehicleDataUnitAgent.vue?vue&type=script&lang=ts&"
export * from "./RelatedVehicleDataUnitAgent.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedVehicleDataUnitAgent.vue?vue&type=style&index=0&id=da78018a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da78018a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
